import { lazy, Suspense } from "react";
import Navigation from "@/components/Navigation";
import Hero from "@/components/Hero";
import Stats from "@/components/Stats";

// Lazy load below-the-fold components to reduce initial JS parsing
const About = lazy(() => import("@/components/About"));
const WhyConventure = lazy(() => import("@/components/WhyConventure"));
const Services = lazy(() => import("@/components/Services"));
const Impact = lazy(() => import("@/components/Impact"));
const Sectors = lazy(() => import("@/components/Sectors"));
const Team = lazy(() => import("@/components/Team"));
const Footer = lazy(() => import("@/components/Footer"));

// Minimal loading placeholder that doesn't cause layout shift
const SectionFallback = () => (
  <div className="min-h-[200px]" aria-hidden="true" />
);

const Index = () => {
  return (
    <div className="min-h-screen">
      <Navigation />
      <Hero />
      <main>
        <Stats />
        <Suspense fallback={<SectionFallback />}>
          <About />
        </Suspense>
        <Suspense fallback={<SectionFallback />}>
          <WhyConventure />
        </Suspense>
        <Suspense fallback={<SectionFallback />}>
          <Services />
        </Suspense>
        <Suspense fallback={<SectionFallback />}>
          <Impact />
        </Suspense>
        <Suspense fallback={<SectionFallback />}>
          <Sectors />
        </Suspense>
        <Suspense fallback={<SectionFallback />}>
          <Team />
        </Suspense>
      </main>
      <Suspense fallback={<SectionFallback />}>
        <Footer />
      </Suspense>
    </div>
  );
};

export default Index;
